import { registerBlock } from '../../core/registry.js';
import { ImageCanvas, ImageInspector } from './Canvas.jsx';

const definition = {
  type: 'image',
  schema: {
    defaults: () => ({ url: '', alt: '', caption: '', isVideo: false }),
  },
  capabilities: {
    isContainer: false,
  },
  ui: {
    Canvas: ImageCanvas,
    Inspector: ImageInspector,
    icon: '🖼️',
    label: 'Image / Video',
    keywords: ['image', 'photo', 'video', 'media', 'youtube', 'vimeo'],
  },
  serialize: (attrs) => {
    if (attrs.isVideo) {
      return attrs.url
        ? `<div class="video-embed"><iframe src="${attrs.url}" allowfullscreen loading="lazy"></iframe></div>`
        : '';
    }
    const caption = attrs.caption
      ? `<figcaption>${attrs.caption}</figcaption>`
      : '';
    return attrs.url
      ? `<figure><img src="${attrs.url}" alt="${attrs.alt || ''}" />${caption}</figure>`
      : '';
  },
};

registerBlock(definition);
export default definition;
